import HeaderSection from '../admin/HeaderSection'
import SignInHeader from '../admin/SignInHeader'
import MainHeader from '../common/MainHeader'
import ActivitySummaryLayout from '../layout/ActivitySummaryLayout'
import AdminContentLayout from '../layout/AdminContentLayout'
import ActivitySummaryWrongBox from './ActivitySummaryWrongBox'

const ActivitySummaryWrong = () => {
  return (
    <ActivitySummaryLayout>
      <SignInHeader />
      <ActivitySummaryWrongBox />
    </ActivitySummaryLayout>
  )
}

export default ActivitySummaryWrong
